export class CloudAccount {
  accountId?: string;
  customerId?: string;
  connectAccountId?: string;
  description?: string;
  isEnabled?: boolean;
  inMaintenanceMode?: boolean;
  creationTime?: Date;
  region?: string;
}
